/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_FreeInputs */

const en_landing_pricing_free = /** @type {(inputs: Landing_Pricing_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const zh_landing_pricing_free = /** @type {(inputs: Landing_Pricing_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Landing_Pricing_FreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_free = /** @type {((inputs?: Landing_Pricing_FreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_FreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_free(inputs)
	return zh_landing_pricing_free(inputs)
});
export { landing_pricing_free as "landing.pricing.free" }